const Loader = () => {
    return <div className="loading">
            <div className="loader">
                <img src={window.ImgSrc.get('loading.gif')} alt="Chargement" />
            </div>
        </div>;
}

export default Loader;